import React, { useContext } from "react";
import "./SocialMedia.scss";
import { socialMediaLinks } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";

export default function SocialMedia() {
  const { isDark } = useContext(StyleContext);

  if (!socialMediaLinks.display) {
    return null;
  }
  
  return (
    <div className={`social-media-div ${isDark ? "dark-mode" : ""}`}>
      {socialMediaLinks.github ? (
        <a
          href={socialMediaLinks.github}
          className="icon-button github"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-github"></i>
          <span></span>
        </a>
      ) : null}

      {socialMediaLinks.linkedin ? (
        <a
          href={socialMediaLinks.linkedin}
          className="icon-button linkedin"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fab fa-linkedin-in"></i>
          <span></span>
        </a>
      ) : null}

      {socialMediaLinks.gmail ? (
        <a
          href={`mailto:${socialMediaLinks.gmail}`}
          className="icon-button google"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="fas fa-envelope"></i>
          <span></span>
        </a>
      ) : null}
    </div>
  );
}
